/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { AdminWorkstreamImporterMetricPreview } from './AdminWorkstreamImporterMetricPreview';
import type { AdminWorkstreamImporterMilestonePreview } from './AdminWorkstreamImporterMilestonePreview';
import type { AdminWorkstreamImporterPerson } from './AdminWorkstreamImporterPerson';

export type AdminWorkstreamImporterRowPreview = {
    row_index: number;
    kind: AdminWorkstreamImporterRowPreview.kind;
    valid: boolean;
    errors?: Array<string>;
    warnings?: Array<string>;
    error_fields?: Array<string>;
    workstream_name?: (string | null);
    objective?: (string | null);
    dri_text?: (string | null);
    dri?: (AdminWorkstreamImporterPerson | null);
    headcount?: (string | null);
    workstream_exists?: boolean;
    existing_workstream_id?: (number | null);
    parent_workstream_name?: (string | null);
    metrics?: Array<AdminWorkstreamImporterMetricPreview>;
    milestones?: Array<AdminWorkstreamImporterMilestonePreview>;
};

export namespace AdminWorkstreamImporterRowPreview {

    export enum kind {
        PARENT = 'parent',
        CHILD = 'child',
    }


}

